import { ColumnHeaders } from '../../../model/ColumnHeaders.model';
import { UnavailabilityTypeEnum } from '../../../consts/unavailability-types';

export const REPAIRER_SITES_SEARCH_PLACEHOLDER =
  'Company Name, Physical Address Suburb, Physical Address Postcode, Repairer ID, Repairer Group';

export const REPAIRER_SITES_STATUS_OPTIONS: { label: string; value: string }[] = [
  { label: 'All', value: '' },
  { label: 'Active', value: 'ACTIVE' },
  { label: 'Unpaid License Fee', value: 'UNPAID' },
  { label: 'Suspended', value: 'SUSPENDED' },
  { label: UnavailabilityTypeEnum.ABN_CHANGE, value: 'ABN_CHANGE' },
  { label: 'Archived', value: 'ARCHIVED' },
  { label: UnavailabilityTypeEnum.AT_CAPACITY, value: 'AT_CAPACITY' },
  { label: UnavailabilityTypeEnum.SHOP_CLOSURE, value: 'SHOP_CLOSURE' },
  { label: 'Pending', value: 'PENDING' }
];

const REPAIRER_SITES_TABLE_HEADERS_BASE: ColumnHeaders[] = [
  {
    matColumnDef: 'flagged'
  },
  {
    matColumnDef: 'companyName',
    columnTitle: 'Company Name',
    property: 'companyName'
  },
  {
    matColumnDef: 'id',
    columnTitle: 'Repairer ID',
    property: 'id'
  },
  {
    matColumnDef: 'repairerGroup',
    columnTitle: 'Repairer Group',
    property: 'repairerGroupName'
  },
  {
    matColumnDef: 'abn',
    columnTitle: 'ABN',
    property: 'abn'
  },
  {
    matColumnDef: 'addressLine1',
    columnTitle: 'Address',
    property: 'addressString'
  },
  {
    matColumnDef: 'mainContact.phone',
    columnTitle: 'Phone',
    property: 'mainContact.phone'
  },
  {
    matColumnDef: 'quotingSystems',
    columnTitle: 'Quoting System',
    property: 'quotingSystemsString'
  },
  {
    matColumnDef: 'published',
    columnTitle: 'Published',
    property: 'publishedDateTime'
  }
];

const REPAIRER_SITES_TABLE_HEADERS_END: ColumnHeaders[] = [
  {
    matColumnDef: 'status',
    columnTitle: 'Status'
  },
  {
    matColumnDef: 'kebab'
  }
];

export const REPAIRER_SITES_TABLE_HEADERS_DEFAULT: ColumnHeaders[] = [
  ...REPAIRER_SITES_TABLE_HEADERS_BASE,
  ...REPAIRER_SITES_TABLE_HEADERS_END
];

export const REPAIRER_SITES_TABLE_HEADERS_SUSPENDED: ColumnHeaders[] = [
  ...REPAIRER_SITES_TABLE_HEADERS_BASE,
  {
    matColumnDef: 'suspended',
    columnTitle: 'Suspended',
    property: 'licenseSuspendedDate'
  },
  ...REPAIRER_SITES_TABLE_HEADERS_END
];

export const REPAIRER_SITES_TABLE_HEADERS_UNPAID: ColumnHeaders[] = [
  ...REPAIRER_SITES_TABLE_HEADERS_BASE,
  {
    matColumnDef: 'projected',
    columnTitle: 'Projected Suspension',
    property: 'licenseSuspensionDate'
  },
  ...REPAIRER_SITES_TABLE_HEADERS_END
];

export const REPAIRER_SITES_KEBAB_OPTIONS = [
  {
    label: 'Access Repairer Site',
    action: 'AccessRepairerItem'
  },
  {
    label: 'Archive Repairer Site',
    action: 'ArchiveRepairerItem'
  },
  {
    label: 'Change Company Name',
    action: 'ChangeCompanyName'
  },
  {
    label: 'Change Quoting System',
    action: 'ChangeQuotingSystem'
  },
  {
    label: 'Clear Unpaid License',
    action: 'ClearUnpaidLicense'
  },
  {
    label: 'Delete',
    action: 'Delete'
  },
  {
    label: 'Flag Unpaid License',
    action: 'FlagUnpaidLicense'
  },
  {
    label: 'Re-invite repairer',
    action: 'ReInviteRepairer'
  },
  {
    label: 'Request Screen Sharing',
    action: 'RequestScreenSharing'
  },
  {
    label: 'Restore Repair Site',
    action: 'RestoreRepairSite'
  },
  {
    label: 'Revoke All Tokens',
    action: 'RevokeAllTokens'
  },
  {
    label: 'Set Autoarchive Days',
    action: 'SetAutoArchiveDays'
  },
  {
    label: 'Set Repairer Status',
    action: 'SetRepairerStatus'
  },
  {
    label: 'Suspend Repair Site',
    action: 'SuspendRepairSite'
  }
];
